import React, { useEffect, useRef } from 'react';

import SearchIcon from 'Assets/icons/search.svg';

/**
 * Substring search box for the picker (IB-641). Focuses on ⌘K / Ctrl+K while the
 * picker is open.
 */
export default function PickerSearch({ value, onChange }) {
    const inputRef = useRef(null);

    useEffect(() => {
        const onKeyDown = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
                e.preventDefault();
                inputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', onKeyDown);

        return () => window.removeEventListener('keydown', onKeyDown);
    }, []);

    return (
        <div className="tw-flex tw-items-center tw-gap-2 tw-border-2 tw-border-grey tw-rounded-lg tw-px-3 tw-py-2 tw-bg-white">
            <SearchIcon className="tw-w-3.5 tw-h-3.5 tw-text-charcoal-50" />
            <input
                ref={inputRef}
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={$t('Search projects (⌘K)')}
                className="tw-flex-1 tw-bg-transparent tw-text-sm tw-text-charcoal tw-border-0 tw-p-0 focus:tw-ring-0"
            />
        </div>
    );
}
